module.exports = __webpack_public_path__ + "static/media/marker-green.afb582f9.png";